import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import api from '../views/services/api';

const AccountTypeContext = createContext({ accountType: null });

export const AccountTypeProvider = ({ children }) => {
    const [accountType, setAccountType] = useState(null);
    const mountedRef = useRef(true);

    useEffect(
        () => () => {
            mountedRef.current = false;
        },
        []
    );

    useEffect(() => {
        api.get('v1/apps/default/')
            .then((res) => {
                if (mountedRef.current) setAccountType(res.data.account_type);
            })
            .catch(() => {
                if (mountedRef.current) setAccountType(null);
            });
    }, []);

    return <AccountTypeContext.Provider value={{ accountType }}>{children}</AccountTypeContext.Provider>;
};

AccountTypeProvider.propTypes = {
    children: PropTypes.node
};

export const useAccountType = () => useContext(AccountTypeContext);
